
        var result = require("!!../../../../node_modules/css-loader/index.js!./announcement-show.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/announcement-show/announcement-show.component.css
// module id = 574
// module chunks = 0